// Pclshm family 0.1.0 — generated by pclshm-kit/design-system/build.mjs from shell/shell.js.
// Family shell behaviour, shared by every public pclshm website. Progressive
// enhancement only: the header, menu and footer work without it.
(() => {
  if (typeof document === 'undefined' || document.documentElement.dataset.familyShell) return;
  document.documentElement.dataset.familyShell = 'ready';

  // The menu closes on navigation, on Escape and on a click outside it.
  const menu = /** @type {HTMLDetailsElement | null} */ (document.querySelector('.fam-menu'));
  if (menu) {
    menu.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => { menu.open = false; }));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary')?.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (menu.open && event.target instanceof Node && !menu.contains(event.target)) menu.open = false;
    });
  }

  // Every site opens its own storage settings from one event, so the footer
  // button needs no per-site wiring.
  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element && event.target.closest('[data-family-storage]');
    if (trigger) window.dispatchEvent(new CustomEvent('family:storage-settings'));
  });

  // The theme switch: each choice sets data-theme on the root, is remembered for the next visit
  // (theme.js reads it back before first paint) and repaints the browser's own chrome to match.
  const root = document.documentElement;
  const choices = /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll('[data-theme-choice]'));
  const header = document.querySelector('.fam-header');
  const syncTheme = () => {
    for (const choice of choices) choice.setAttribute('aria-pressed', String(choice.dataset.themeChoice === root.dataset.theme));
    const ground = header && getComputedStyle(header).getPropertyValue('--fam-surface').trim();
    if (ground) document.querySelector('meta[name="theme-color"]')?.setAttribute('content', ground);
  };
  for (const choice of choices) {
    choice.addEventListener('click', () => {
      const theme = choice.dataset.themeChoice === 'light' ? 'light' : 'dark';
      root.dataset.theme = theme;
      try {
        localStorage.setItem('pclshm.theme', theme);
      } catch {}
      syncTheme();
      window.dispatchEvent(new CustomEvent('family:theme', { detail: { theme } }));
    });
  }
  if (choices.length) syncTheme();

  // Mark the page you are on, then the section in view, in the header navigation.
  const page = (/** @type {string} */ path) => path.replace(/index\.html$/, '');
  const links = new Map();
  for (const link of document.querySelectorAll('.fam-nav a, .fam-menu__panel a')) {
    const url = new URL(link.getAttribute('href') ?? '', location.href);
    if (url.origin !== location.origin || page(url.pathname) !== page(location.pathname)) continue;
    if (!url.hash) link.setAttribute('aria-current', 'page');
    else if (link.closest('.fam-nav')) links.set(decodeURIComponent(url.hash.slice(1)), link);
  }
  if (!links.size || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        for (const link of links.values()) link.removeAttribute('aria-current');
        links.get(entry.target.id)?.setAttribute('aria-current', 'true');
      }
    },
    { rootMargin: '-45% 0px -50% 0px' },
  );
  for (const id of links.keys()) {
    const section = document.getElementById(id);
    if (section) observer.observe(section);
  }
})();
